document.addEventListener("DOMContentLoaded", function() {
	function toggleSwiperClass($element) {
		$element.toggleClass("swiper")
		$element.find(".sw-wrapper").toggleClass("swiper-wrapper")
		$element.find(".sw-slide").toggleClass("swiper-slide")
		$element.find(".sw-scrollbar").toggleClass("swiper-scrollbar")
		$element.find(".sw-prev").toggleClass("swiper-button-prev")
		$element.find(".sw-next").toggleClass("swiper-button-next")
		$element.find(".sw-pagination").toggleClass("swiper-pagination")
	}

	var prodTabs = (function() {
		var $nav = $(".mproduct__tabs__nav button")

		if (!$nav.length) {
			return
		}

		var $tabs = $(".mproduct__tabs__tab")

		$nav.click(function() {
			var $this = $(this)
			var type = $this.data("tab")

			$nav.removeClass("active")
			$this.addClass("active")

			$tabs.removeClass("active")
			$tabs.filter('[data-tab="' + type + '"]').addClass("active")
		})
	})()
	;(function() {
		// Product Gallery
		const $sliders = $(".mproduct__main-gallery")
		// Product Alternative Gallery
		const $slidersAlt = $(".mproduct-alternative__main-gallery")

		if ($sliders.length) {
			const $slidersThumb = $(".mproduct__thumb-gallery")

			toggleSwiperClass($slidersThumb)

			const sliderThumb = new Swiper($slidersThumb[0], {
				createElements: false,
				centeredSlides: false,
				loop: false,
				slidesPerView: 3,
				spaceBetween: 15,
				slideToClickedSlide: true,
				direction: "horizontal",
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev"
				},
				breakpoints: {
					440: {
						direction: "horizontal",
						slidesPerView: 5,
						spaceBetween: 15
					},
					540: {
						direction: "vertical",
						slidesPerView: 5,
						spaceBetween: 15
					},
					1320: {
						spaceBetween: 22,
						direction: "vertical",
						slidesPerView: 5
					}
				}
			})

			toggleSwiperClass($sliders)

			new Swiper($sliders[0], {
				createElements: false,
				slidesPerView: 1,
				centeredSlides: false,
				loop: false,
				spaceBetween: 0,
				thumbs: { swiper: sliderThumb }
			})
		} else if ($slidersAlt.length) {
			const $slidersThumbAlt = $(".mproduct-alternative__thumb-gallery")

			toggleSwiperClass($slidersThumbAlt)

			const sliderThumbAlt = new Swiper($slidersThumbAlt[0], {
				createElements: false,
				centeredSlides: false,
				loop: true,
				slidesPerView: 3,
				spaceBetween: 15,
				slideToClickedSlide: true,
				direction: "horizontal",
				breakpoints: {
					440: {
						direction: "horizontal",
						slidesPerView: 5,
						spaceBetween: 15
					},
					540: {
						direction: "horizontal",
						slidesPerView: 5,
						spaceBetween: 15
					},
					1320: {
						spaceBetween: 22,
						direction: "horizontal",
						slidesPerView: 5
					}
				}
			})

			toggleSwiperClass($slidersAlt)

			new Swiper($slidersAlt[0], {
				createElements: false,
				slidesPerView: 1,
				centeredSlides: false,
				loop: false,
				spaceBetween: 0,
				navigation: {
					nextEl: ".sw-alt-next",
					prevEl: ".sw-alt-prev"
				},
				thumbs: { swiper: sliderThumbAlt }
			})
		} else {
			return
		}
	})()
	;(function() {
		jQuery(document).ready(function($) {
			$(".mproduct__main-gallery .product-image img").click(function() {
				var smallImg = $(this)
				var src = smallImg.attr("src")

				var zoom =
					"<div class='zoom-box'>" +
					"<div class='zoom-box_bg'></div>" +
					"<img src='" +
					src +
					"' class='zoom-box_img' />" +
					"</div>"

				$("body").append(zoom)
				$("body").addClass("no-scroll")
				$(".zoom-box").fadeIn(500)

				$(".zoom-box_bg").click(function() {
					$(".zoom-box").fadeOut(500)
					$("body").removeClass("no-scroll")
					setTimeout(function() {
						$(".zoom-box").remove()
					}, 500)
				})

				$(".zoom-box_img").click(function() {
					$(".zoom-box").fadeOut(500)
					$("body").removeClass("no-scroll")
					setTimeout(function() {
						$(".zoom-box").remove()
					}, 500)
				})
			})
		})
	})()
})
